import { useState } from "react";
import { useDebounce } from "../../../hooks/useDebounce";
import { useFuseSearch } from "../../../hooks/useFuseSearch";
import { AnySelectOption } from "./SelectOption";

export type UseSearchOptionsParams<TOption extends AnySelectOption> = {
  options: TOption[];
  enabled: boolean;
  maxOptionsDisplayed?: number;
};

export function useSearchOptions<TOption extends AnySelectOption>({
  options,
  enabled,
  maxOptionsDisplayed,
}: UseSearchOptionsParams<TOption>) {
  const [searchValue, setSearchValue] = useState("");

  const debouncedSearchValue = useDebounce(searchValue, 100);

  const searchedOptions = useFuseSearch(
    options,
    searchKeys,
    debouncedSearchValue,
    {
      enabled,
      maxResults: maxOptionsDisplayed,
    },
  );

  return {
    searchValue,
    setSearchValue,
    searchedOptions,
  };
}

const searchKeys = ["label", "description", "keywords"];
